export default {"src":"/_next/static/media/ua.f2fcca8e.svg","height":480,"width":640,"blurWidth":0,"blurHeight":0};